import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import jQuery from 'jquery'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

window.$ = window.jQuery = jQuery

import 'popper.js'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, digits, min, integer, regex, numeric } from 'vee-validate/dist/rules';

extend('email', {
  ...email,
  message: 'The {_field_} field must be a valid email'
});

extend('digits', {
  ...digits,
  message: 'The {_field_} field must be numeric and extactly contain {length} digits'
});

extend('numeric', {
  ...numeric,
  message: 'The {_field_} field may only contain numeric characters'
});

extend('min', {
  ...min,
  message: 'The {_field_} must be at least {length} characters'
});

extend('integer', integer);

extend('regex', {
  ...regex,
  message: 'The {_field_} field must be numbers only'
});

// Override the default message.
extend('required', {
  ...required,
  message: 'The {_field_} field is required'
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.productionTip = false

new Vue({
  created() {
    AOS.init()
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
